import {
  AppLogoLink,
  GearboxFooter,
  Header,
  Layout,
} from "@gearbox-protocol/ui-kit";
import { ConnectKitButton } from "connectkit";
import { Toaster } from "sonner";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <Layout
      header={
        <Header
          logo={<AppLogoLink appName="Bytecode Repository" />}
          actions={<ConnectKitButton mode="dark" />}
        />
      }
      footer={
        <GearboxFooter
          appName="Bytecode Repository"
          legalAppName="Bytecode Repository"
          showLegalLinks
          showDeveloperLinks
          legalReferences={{
            termsOfService: "/legal/terms-of-service",
            privacyNotice: "/legal/privacy-notice",
            riskDisclosure: "/legal/risk-disclosure",
          }}
        />
      }
    >
      <Toaster position="top-right" richColors theme="dark" closeButton />
      {children}
    </Layout>
  );
}
